/**
 * Copyright © 1998 - 2018 Tencent. All Rights Reserved.
 *
 * @author freedeng
 */

import type IFormatLocale from './FormatLocale';

const en: IFormatLocale = {
    name: 'en',
    weekdays: 'SUNDAY_MONDAY_TUESDAY_WEDNESDAY_THURSDAY_FRIDAY_SATURDAY'.split('_'),
    weekdaysShort: 'SUN_MON_TUE_WED_THU_FRI_SAT'.split('_'),
    months: 'JANUARY_FEBRUARY_MARCH_APRIL_MAY_JUNE_JULY_AUGUST_SEPTEMBER_OCTOBER_NOVEMBER_DECEMBER'.split('_'),
    monthsShort: 'JAN_FEB_MAR_APR_MAY_JUN_JUL_AUG_SEP_OCT_NOV_DEC'.split('_'),
};

export default en;
